/** Visionary v1.2 feature pack */
'use strict';

(function () {
  const html = document.documentElement;
  const lock = () => html.classList.add('visionary-modal-open');
  const unlock = () => {
    if (!document.querySelector('.visionary-search-modal:not([hidden]), .cart-drawer.is-open')) {
      html.classList.remove('visionary-modal-open');
    }
  };

  // Search modal open/close behavior is handled by the <search-modal> component.

  // Close any open localization disclosure when clicking away
  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-localization-switcher] details[open]').forEach((details) => {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  });

  // Back-to-top behavior is handled by theme.js.

  // Quick buy for one-variant product cards
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.product-card__quick-add-form');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    const formData = new FormData(form);
    const id = formData.get('id');
    const quantity = Number(formData.get('quantity') || 1);
    const properties = {};
    formData.forEach((value, key) => {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match && value !== '') properties[match[1]] = value;
    });
    if (!id || !window.CartAPI) { form.submit(); return; }
    button?.setAttribute('disabled', '');
    form.classList.add('is-loading');
    try {
      const result = await CartAPI.addItems({ id, quantity, ...(Object.keys(properties).length ? { properties } : {}) });
      document.dispatchEvent(new CustomEvent('cart:added', { detail: result.items?.[0] || result }));
      document.dispatchEvent(new CustomEvent('cart:updated'));
    } catch (error) {
      console.error('[Visionary quick buy]', error);
      window.alert(error.message || 'Could not add this item to the cart.');
    } finally {
      button?.removeAttribute('disabled');
      form.classList.remove('is-loading');
    }
  });

  // Gift wrapping add/remove
  document.addEventListener('change', async (event) => {
    const toggle = event.target.closest('[data-gift-wrap-toggle]');
    if (!toggle || !window.CartAPI) return;
    const control = toggle.closest('[data-gift-wrap-control]');
    const status = control?.querySelector('[data-gift-wrap-status]');
    const variantId = Number(toggle.dataset.variantId || 0);
    if (!variantId) return;
    control?.classList.add('is-loading');
    try {
      if (toggle.checked) {
        await CartAPI.addItems({ id: variantId, quantity: 1, properties: { '_Gift wrap': 'Yes' } });
      } else {
        const cart = await CartAPI.getCart();
        const updates = {};
        cart.items.forEach((item) => { if (Number(item.variant_id) === variantId) updates[item.key] = 0; });
        if (Object.keys(updates).length) await CartAPI.updateCart(updates);
      }
      if (status) status.textContent = toggle.checked ? 'Gift wrapping added.' : 'Gift wrapping removed.';
      document.dispatchEvent(new CustomEvent('cart:updated'));
      const drawer = document.querySelector('cart-drawer');
      if (drawer?.refresh) await drawer.refresh();
      if (document.body.classList.contains('template-cart')) window.location.reload();
    } catch (error) {
      toggle.checked = !toggle.checked;
      if (status) status.textContent = 'Unable to update gift wrapping.';
      console.error('[Visionary gift wrap]', error);
    } finally {
      control?.classList.remove('is-loading');
    }
  });

  // Cart note autosave for drawer
  document.addEventListener('change', (event) => {
    const note = event.target.closest('[data-cart-note]');
    if (note && window.CartAPI) CartAPI.updateNote(note.value).catch(console.error);
  });

  // Re-activate dynamically inserted product cards after infinite scroll.
  document.addEventListener('collection:updated', () => {
    document.querySelectorAll('.product-card__quick-actions').forEach((el) => el.removeAttribute('aria-hidden'));
  });
})();
